// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { CheckCircle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCheckCircle(props: any) {
    return <IconBase icon={CheckCircle} {...props} />
  }

  export default IconCheckCircle
  